// src/pages/profesionales/SuspenderProfesional.js
import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'

function SuspenderProfesional(props) {
	const { profesional, setQueMostrar, suspender } = props

	const handleClose = () => {
		setQueMostrar('')
	}

	return (
		<Modal show={true} onHide={handleClose}>
			<Modal.Header closeButton>
				<Modal.Title>Suspender Profesional</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Alert variant="danger">
					Estás a punto de suspender a <strong>{`${profesional.nombre} ${profesional.apellido}`}</strong>.
				</Alert>
				<p>Esta acción impedirá que el profesional pueda ofrecer servicios en la plataforma hasta que sea habilitado nuevamente.</p>
				<p>¿Estás seguro que desea continuar?</p>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="outline-tertiary" onClick={handleClose}>
					Cancelar
				</Button>
				<Button variant="danger" onClick={() => suspender(profesional.id)}>
					Suspender
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default SuspenderProfesional